<template>
  <transition name="fade">
	<div class="shopcart" :style="{bottom: bottomValue  + 'px' }">
		<div class="content" @click="toggleList">
			<div class="content-left">
				<div class="logo-wrapper">
					<div class="logo" :class="{'on':totalCount>0}" >
						<i class="icon-shopping_cart"></i>
					</div>
					<div class="num" v-show="totalCount>0">
						{{totalCount}}
					</div>
				</div>
				<div class="price" :class="{'on':totalCount>0}">已添加{{totalCount}}个商品</div>
			 
			</div>
			<div class="content-right">
			<div class="save" :class="saveClass" @click.stop.prevent="save">
					暂存订单
				</div>
					 
				<div class="pay" :class="payClass"   @click.stop.prevent="pay">
					 {{tijiaotext}}
				</div>
			</div>
			<!-- 定义动画小球： -->
			<div class="ball-container">
                <div v-for="ball in balls" :key="ball.id">
                    <transition name="drop" @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter">
                        <div v-show="ball.show" class="ball">
                            <div class="inner inner-hook">
                            </div>
                        </div>
                    </transition>
                </div> 
            </div>
			
			
			
			 <!-- 商品详情页展示 -->
  
        <div class="shopcart-list" v-show="listShow">
          <div class="list-header">
            <h1 class="title">购物车</h1>
       
			  <span class="close"   @click="empty()">清空</span>
          </div>
        <div class="list-content" ref="listContent">
          <ul>
            <li class="food" v-for="(food,index) in selectFood" :key="index">
              <span class="name">{{food.cp_name}}</span>
             
              <div class="cartcontrol-wrapper">
                <cartcontrol :food="food"  :dancicaigou="food.dancicaigou" 
                    v-on:cart-add="cartAdd"   @shopcartshow-input="openInputModal" ></cartcontrol>
              </div>
            </li>
          </ul>
        </div>
        </div>
      
 
			
			
			

		</div>
	  <div class="list-mask" v-show="listShow" @click="hideList()"></div>
    </div>
	 
	</div>
	
	  </transition>
</template>

<script>
import Vue from 'vue';
import {
createOrder,savegoods
} from "@api/order";
import store from "@utils/store/cookie";
 import cartcontrol from '../../components/cartcontrol/cartcontrol'
 import InputModal from '../../components/input/InputModal.vue' // 新建的弹窗组件
 import  dialog from "@utils/dialog";
import BScroll from 'better-scroll';
export default {
  props:{
  	// 由父元素传递进来选中的商品：
  	selectFood:{
  		type:Array,
  		default(){
  			// 默认数据（可以测试数据）
  			return [{
  			
  				count:1 
  			}];
  		}
  	}
  	 
   
  },
  components: {
    cartcontrol
  },
  computed:{
   
  	// 获取总数：
  	totalCount(){
  		let count=0;
  		this.selectFood.forEach(function(food){
  			count+=food.count;
  		});
  		return this.selectFood.length;
  	},
  	payDesc(){
  		 
  			return `去结算`;
  	 
  	},
  	payClass(){
  		if(this.totalCount>0){
		return 'enough';
  			 
  		}else{
  		return 'not-enough'
  		}
  	},
		saveClass(){
  		if(this.totalCount>0){
		return 'enough';
  			 
  		}else{
  		return 'not-enough'
  		}
  	},
	listShow () {
      // get: function () {
      //   return this.fold
      // },
      // set: function () {
      //   if (!this.totalCount) {
      //     this.fold = false
      //     return false
      //   }
      //   let show = !this.fold
      //   if (show) {
      //      this.$nextTick(() => {
      //       if (!this.scroll) {
      //         this.toScorll()
      //       } else {
      //         this.scroll.refresh()
      //       }
      //     })
      //   }
      //   return show
      // }
      if (!this.totalCount) {
        // 计算属性无法直接修改data里面的数据，因此我们调用toFalse函数修改isShow的值
        this.toFalse()
        return false
      }
      let show = !this.fold
      if (show) {
	    this.bottomValue = 0;
        // 由于这里计算属性还是无法修改data里面的值，因此我们将对scroll的操作封装成一个函数toScroll，这里调用函数就可以
        // this.$nextTick(() => {
        //   if (!this.scroll) {
        //    this.toScorll()
        //   } else {
        //     this.scroll.refresh()
        //   }
        // })
        this.toScorll()
      }else{
	    this.bottomValue = 50;
	  
	  }
      return show
    }
 
  },
  methods:{
    closeModal(instance, div) {
  console.log(instance);
    this.$nextTick(() => { // Vue官方推荐的DOM更新等待机制
    if (div.parentNode) {
      document.body.removeChild(div);
    }
    instance.$destroy();
	this.modalInstance = null;
   // this.unlockScroll();
  });
  
  
  },
  // 新增方法：打开输入弹窗
    openInputModal(food) {
	console.log('open');
     const ModalComponent = Vue.extend(InputModal);
  const instance = new ModalComponent({
    propsData: {
      value: food.count || 0,
      food: food
    }
  });

  const div = document.createElement('div');
  document.body.appendChild(div);
  instance.$mount(div);
 
  
   // 监听input事件
  instance.$on('input', value => {
    console.log(value);
    if (value > 0) {
      this.$set(food, 'count', value);
    } else {
      this.$delete(food, 'count');
    }
  });
  
   
     // 优化关闭事件处理
  instance.$on('close', () => {
  console.log('close');
instance.$destroy();        // 销毁Vue实例
  instance.$el.remove();      // 移除DOM节点（推荐）
// this.unlockScroll();
 
  });



      
    },
	// 改进的滚动锁定方法
    lockScroll() {
      // 记录当前滚动位置
      this.scrollPosition = {
        left: window.pageXOffset,
        top: window.pageYOffset
      }
      
      // 锁定body滚动
      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
      document.body.style.top = `-${this.scrollPosition.top}px`
      document.body.style.left = `-${this.scrollPosition.left}px`
      
      // 锁定better-scroll滚动
      if (this.foodScroll) this.foodScroll.disable()
      if (this.menuScroll) this.menuScroll.disable()
    },
    
    unlockScroll() {
      // 恢复body滚动
      document.body.style.position = ''
      document.body.style.width = ''
      document.body.style.top = ''
      document.body.style.left = ''
      
      // 恢复滚动位置
      window.scrollTo(this.scrollPosition.left, this.scrollPosition.top)
      
      // 解锁better-scroll滚动
      if (this.foodScroll) this.foodScroll.enable()
      if (this.menuScroll) this.menuScroll.enable()
    },
  	drop(el) {
  		//console.log(el);
  		for(let i=0;i<this.balls.length;i++){
  			let ball=this.balls[i];
  			if(!ball.show){
  				ball.show=true;
  				ball.el=el;
  				this.dropBalls.push(ball);
  				return;
  			}
  		}
  	},
  	//定义三个钩子函数实现动画
    beforeEnter(el) { //el为当前执行transition动画的DOM对象
    //先找到所有为true的小球（连续点击的情况）
        let count = this.balls.length;
        while (count--) {
            let ball = this.balls[count];
            if (ball.show) { //这个是要运动的小球true
                let rect = ball.el.getBoundingClientRect();//获得元素相当于视口的位置
                let x = rect.left - 32;
                let y = -(window.innerHeight - rect.top - 22);
                    // console.log(y)
                el.style.display = ''; //v-show默认display：none，设置为空，让它显示
                //外层元素是纵向的动画，内层元素是横向的动画
                el.style.webkitTransform = `translate3d(0,${y}px,0)`;
                el.style.transform = `translate3d(0,${y}px,0)`;
                let inner = el.getElementsByClassName('inner-hook')[0];

                inner.style.webkitTransform = `translate3d(${x}px, 0, 0)`;
                inner.style.transform = `translate3d(${x}px, 0, 0)`;
            }
        }
    },           
    enter(el) {
        /* 触发浏览器重绘，重绘之后才可以设置transform*/
        /* eslint-disable no-unused-vars */
        let rf = el.offsetHeight;
        this.$nextTick(() => { //样式重置
            el.style.webKitTransform = 'translate3d(0,0,0)';//没有变量时只能用单引，不能用反引
            el.style.transform = 'translate3d(0,0,0)';
            let inner = el.getElementsByClassName('inner-hook')[0];
            inner.style.webkitTransform = 'translate3d(0,0,0)';
            inner.style.transform = 'translate3d(0,0,0)';
        });
    },
    afterEnter(el) { //动画完成
        let ball = this.dropBalls.shift();//删除并返回第一个ball
        if (ball) {
            ball.show = false; //重置ball.show的状态
            el.style.display = 'none';
        }
    },	
	// 展开折叠
    toggleList () {
      if (!this.totalCount) {
        return
      }
     // this.fold = !this.fold
	  
	    this.fold =false
	     
    },
    // 修改isShow
    toFalse () {
      this.isShow = false
	  this.bottomValue = 50;
    },
  
    toScorll () {
       this.$nextTick(() => {
          if (!this.scroll) {
           this.scroll = new BScroll(this.$refs.listContent, {
              click: true
          })
          } else {
            this.scroll.refresh()
          }
        })
    },
   
    empty () {
      this.selectFood.forEach((food) => {
        food.count = 0
      })
	    store.remove("cartlist");
	   this.bottomValue = 60;
    },
 
    closecart () {
		    this.fold =true
 
 
    },
    hideList () {
      this.fold = true;
	 
    },
   
    pay () {
	if(this.isClickable){
   this.tijiaotext = '提交中...';
	 console.log(this.isClickable);
	  this.isClickable = false;
	  
	  
	  	 
      if (this.totalCount > 0) {
            dialog.message('正在提交');
			
			
		 
			
			  createOrder(this.selectFood).then(res => {
			  
			  console.log(res);
			 if(res.code==1){
			 
		 
	   store.remove("cartlist");
		  this.selectFood.forEach((food) => {
        food.count = 0
       })
		     dialog.message('提交成功');
	  
	    setTimeout(() => {
 

        this.isClickable = true;
   this.tijiaotext = '提交订单';

      }, 500);
	 }else{
	 
	 dialog.message(res.msg);
	 }
      });
	  
			
			
			
      }
     return
	  
	 
	  
	}else{
	 console.log('重复点击');
	return false;
	}
	 
 
	  
	  
 
    },
   
    save () {
      if (this.totalCount > 0) {
          
		   
		     store.set("cartlist",this.selectFood);
			
			 console.log(this.selectFood);
			 
		 
	  
			 
			   dialog.message('保存完成');
			
			
			
			
      }
     return
    },
   
    savechangyong () {
      if (this.totalCount > 0) {
          
		   
		   
			
			 console.log(this.selectFood);
			 
			   savegoods(this.selectFood).then(res => {
			  
			  console.log(res);
			 if(res.code==1){
			 
		 
	  //  store.remove("cartlist");
		// this.selectFood.forEach((food) => {
       // food.count = 0
     // })
		     dialog.message('保存完成');
	 }else{
	 
	 dialog.message(res.msg);
	 }
      });
	  
			 
			  // dialog.message('保存完成');
			
			
			
			
      }
     return
    }
 
  },
  name: 'shopcart',
  data () {
    return {
    	balls:[{
    		show:false
    	},{
    		show:false
    	},{
    		show:false
    	},{
    		show:false
    	},{
    		show:false
    	}],
    	dropBalls:[],
		 bottomValue:60,
	  tijiaotext:'提交订单',
				isClickable:true,
		fold: true
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../common/less/index.less";
 
.shopcart{
	position: fixed;
	z-index: 50;
 
	left:0;
	width:100%;
	height:48px;
	.content{
		display: flex;
		background: #141d27;
		height:100%;
		.content-left{
			flex:1;
			.logo-wrapper{
				display:inline-block;
				position: relative;
				top:-10px;
				margin:0 12px;
				padding:6px;
				width:56px;
				height:56px;
				box-sizing: border-box;
				vertical-align:top;
				border-radius: 50%;
				background: #141d27;
				.highlight{
  background: rgb(0,160,220);
  color: #fff;
}
				.logo{
					width:100%;
					height:100%;
					border-radius: 50%;
					background:rgb(43,52,60);
					text-align: center;
					.highlight{
  color: #fff;
}
					.icon-shopping_cart{
						font-size: 24px;
						line-height:44px;
						color: #80858a;
					}
					&.on{
						background: rgb(0,160,220);
						.icon-shopping_cart{
							color:#fff;
						}
					}
				}
			}
			.num{
				position: absolute;
				top:0;
				right:0;
				width:24px;
				height:16px;
				line-height:16px;
				text-align: center;
				border-radius:16px;
				font-size: 9px;
				font-weight:700;
				color:#fff;
				background: rgba(240,20,20);
				box-shadow: 0 4px 8px 0 rgba(0,0,0,0.4);
			}
			.price{
				display:inline-block;
				vertical-align:top;
				line-height:24px;
				margin-top:12px;
				box-sizing:border-box;
				padding-right: 12px;
				border-right: 1px solid rgba(255,255,255,0.1);
				font-size: 16px;
				font-weight: 700;
				color:rgba(255,255,255,.4);
				&.on{
					color:rgba(255,255,255);
				}
			}
			.desc{
				display:inline-block;
				vertical-align:top;
				line-height:24px;
				margin-left:12px;
				margin-top:12px;
				color:rgba(255,255,255,.4);
				font-size: 10px;
			}
		}
		.content-right{
			flex:0 0 200px;
		 
			.pay{
				width:100px;
				height:48px;
				line-height:48px;
				text-align: center;
				font-size: 12px;
				float:right;
				color:rgba(255,255,255,.4);
				font-weight:700;
				background: #2b333b;
				&.not-enough{
					background: #2b333b;
				}
				&.enough{
					background: #00b43c;
					color:#fff;
				}
			}
				.save{
					width:100px;
				height:48px;
				float:left;
				line-height:48px;
				text-align: center;
				font-size: 12px;
				color:rgba(255,255,255,.4);
				font-weight:700;
				background: #2b333b;
				&.not-enough{
					background: #2b333b;
				}
				&.enough{
					background: #ff5722;
					color:#fff;
				}
			}
		}
	}
	 
	 
	
	.ball-container{
		.ball{
			position: fixed;
			left:32px;
			bottom:22px;
			z-index:666;
			&.drop-enter-active{
				transition: all 0.4s cubic-bezier(0.49, -0.29, 0.75, 0.41);
			}
			
			.inner{
				width:16px;
				height:16px;
				border-radius:50%;
				background: rgb(0,160,220);
				transition:all 0.4s linear;
			}

		}
	}
}
.shopcart .shopcart-list{
  position: absolute;
 
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  transform: translate3d(0, -100%, 0)
}
.slide-fade-enter-active, .slide-fade-leave-active{
  transition: all .6s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  transform : translate3d(0, -100%, 0); /*相对当前自身的额高度做偏移*/
}
.slide-fade-enter, .slide-fade-leave{
  transform: translate3d(0, 0, 0);
  opacity: 0;
}
.shopcart .shopcart-list .list-header{
  height: 40px;
  line-height: 40px;
  padding: 0 18px;
  background: #f3f5f7;
  border-bottom: 1px solid rgba(7, 17, 27, 0.1);
}
.shopcart .shopcart-list .list-header .title{
  font-size: 14px;
  float: left;
  color: rgb(7, 17, 27);
}
.shopcart .shopcart-list .list-header .empty{
   
  font-size: 12px;
  color: rgb(0,160,220);
}
.shopcart .shopcart-list .list-header .close{
  float: right;
  font-size: 12px;
  color: rgb(0,0,0);
}
.shopcart .shopcart-list .list-content{
  padding: 0 18px;
  max-height: 400px;
  background: #fff;
  overflow: hidden;
}
.shopcart .shopcart-list .list-content .food{
  position: relative;
  padding: 18px 0;
  box-sizing: border-box;
  border-bottom: 0px solid rgba(7, 17, 27, 0.1);
  margin-bottom:10px;
  bottom:10px;
}
.shopcart .shopcart-list .list-content .food .name{
  font-size: 14px;
  line-height: 24px;
  float:left;
  color: rgb(7, 17, 27);
}
.shopcart .shopcart-list .list-content .food .price{
  position: absolute;
  right: 120px;
  bottom: 12px;
  line-height: 24px;
  font-size: 14px;
  color: rgb(240,20,20);
  font-weight: 700;
}
.shopcart .shopcart-list .list-content .food .cartcontrol-wrapper{
  position: absolute;
  right: 0;
  /* bottom: 3px; */
}
.list-mask{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height:100%;
  z-index: -2;
  backdrop-filter: blur(10px);
  opacity: 1;
  background: rgba(7, 17, 27, 0.6);
}
.fade-enter-active, .fade-leave-active{
  opacity: 1;
  transition: all 0.5s;
  background: rgba(7, 17, 27, 0.6);
}
.fade-enter, .fade-leave{
  opacity: 0;
  background: rgba(7, 17, 27, 0);
}
 
</style>